import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import style from './sale.module.sass';

export const Sale = ({type, handleButtonClick}) => {
  return (
    <div className={style.blackFriday}>
      <div style={{placeItems: 'center', marginLeft:'32px', fontSize: '43px', fontWeight: '900', marginTop: '43px'}}>
        ЖДЕМ<br/>
        НОВЫЙ ГОД
      </div>
      <div style={{marginLeft: '45%', fontSize: '30px', fontWeight: '400', color: '#E4002F', marginTop: '30px'}}>Скидка
        75%
      </div>
      <div style={{marginLeft: '50%', fontSize: '20px', fontWeight: '400', color: 'white', marginTop: '30px'}}>Безлимитный доступ<br/>ко всем курсам<br/>на 12 месяцев
      </div>
      <Link
        to="/cabinet/select_tariff/"
        className={style.buttonBF}
        style={{placeItems: 'center', textDecoration: 'none'}}
        type="button"
      >
        <img  height={244} style={{position: "absolute", bottom:'30px',left:'-25px'}} src={'img/CHE_elf5.png'} alt="aa"/>
        Оформить
      </Link>

    </div>
    /*<div className={cn(style.saleBanner, style[type])}>
      <img alt={'promo'} style={{width:'110px',position:'absolute',right:'10px',top:'25px'}} src={'/img_static/route-promo.png'}/>
      <div style={{fontWeight: '600', fontSize: '30px', marginBottom:'10px'}}>Все курсы<br/>Чевостика<br/>на год</div>
      <div>✔ более 100 игр</div>
      <div>✔ более 100 тестов</div>
      <div>✔ более 100 приключений</div>

      <div style={{display: 'flex',marginTop:'10px'}}>
        <div className={style.promo_price}>Всего<br/> 1990Р</div>
        <div style={{
          marginLeft: '10px',
          padding: '5px',
          fontWeight: 'normal',
          fontSize: '21px',
          color: 'rgba(0,0,0,0.6)'
        }}>Вместо<br/><span style={{textDecoration: 'line-through'}}>6600₽</span><br/>выгода<br/>4610₽

        </div>
      </div>
      <Link
        to="/cabinet/select_tariff/"
        className={style.button}
        onClick={handleButtonClick}
        type="button"
      >
        Купить со скидкой
      </Link>

    </div>*/
  );
};

Sale.propTypes = {
  type: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func
};
